import React from "react";

const TopSection = () => {
  return (
    <div>
      <div className="flex flex-wrap pt-1">
        <div className="w-full px-5 sm:w-1/2 xl:w-1/3">
          <div className="flex items-center px-5 py-6 shadow-sm rounded-md bg-white">
            <div className="p-3 rounded-full bg-green-500 bg-opacity-75">
              <svg
                className="w-8 h-8 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div className="mx-5">
              <h4 className="text-2xl font-semibold text-gray-600 p-0 m-0">
                124
              </h4>
              <div className="text-gray-500">Positive Memo</div>
            </div>
          </div>
        </div>

        <div className="w-full mt-6 px-5 sm:w-1/2 xl:w-1/3 sm:mt-0">
          <div className="flex items-center px-5 py-6 shadow-sm rounded-md bg-white">
            <div className="p-3 rounded-full bg-blue-500 bg-opacity-75">
              <svg
                className="w-8 h-8 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div className="mx-5">
              <h4 className="text-2xl font-semibold text-gray-600 p-0 m-0">
                51
              </h4>
              <div className="text-gray-500">Neutral Memo</div>
            </div>
          </div>
        </div>

        <div className="w-full mt-6 px-5 sm:w-1/2 xl:w-1/3 xl:mt-0">
          <div className="flex items-center px-5 py-6 shadow-sm rounded-md bg-white">
            <div className="p-3 rounded-full bg-red-500 bg-opacity-75">
              <svg
                className="w-8 h-8 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div className="mx-5">
              <h4 className="text-2xl font-semibold text-gray-600 p-0 m-0">
                72
              </h4>
              <div className="text-gray-500">Negative Memo</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopSection;
